module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julia Gregson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Julia Gregson has worked as a journalist and foreign correspondent in the UK, Australia, and the US. She is the author of "), _c('I', [_vm._v("East of the Sun")]), _vm._v(", which was a major bestseller in the UK and won the Romantic Novel of the Year Prize and the Le Prince Maurice Prize there, and "), _c('I', [_vm._v("Monsoon Summer")]), _vm._v(". Her short stories have been published in collections and magazines and read on the radio. She lives in Monmouthshire, Wales.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15zLhsG/tc-custom/9781439117781.jpg?1730546915768",
      "alt": "This image is the cover for the book Band of Angels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Band of Angels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A STORY OF COURAGE, PASSION, AND HEROISM SET AGAINST ONE ")]), _c('b', [_vm._v("OF THE MOST TRAUMATIC WARS IN HISTORY")]), _c('br'), _c('br'), _vm._v("Growing up in Wales, Catherine Carreg has been allowed to run wild, spending her childhood racing ponies along the beach with her friend Deio, the cattle-driver’s son. But Catherine is consumed by a longing to escape the monotony of village life and runs away to London with Deio’s help. Alone in the unfamiliar city, Catherine secures a position in Florence Nightingale’s home for sick governesses. As the nation is gripped by reports of war in the Crimea, Catherine volunteers as a nurse—and her life changes beyond all recognition. Arriving in Scutari, she is immediately thrown into a living nightmare. Amid the madness and chaos, Catherine is forced to grow up quickly, learning the hardest lessons of love and war.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Atria\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0